module.exports = __webpack_public_path__ + "img/insurance-card-mapd.c9a2da9.png";